import React, { useRef, useState, useEffect, useCallback } from 'react'
import classNames from 'classnames'
import SVG from 'components/base/SVG'
import Tile from '.'
import css from './style.scss'

const SCROLL_AMOUNT = 276 // ~2 tiles (132px each + gap)

export default function Carousel({ tileProps, totals, selectedFilter, handleFilterClick, loading }) {
  const scrollRef = useRef(null)
  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)

  const updateScrollButtons = useCallback(() => {
    const el = scrollRef.current
    if (!el) return
    const { scrollLeft, scrollWidth, clientWidth } = el
    // Tolerance absorbs sub-pixel rounding of flex gaps/tiles, which can make
    // scrollWidth ~1px larger than clientWidth even when everything fits.
    const SCROLL_TOLERANCE = 1
    setCanScrollLeft(scrollLeft > SCROLL_TOLERANCE)
    setCanScrollRight(scrollWidth - clientWidth - scrollLeft > SCROLL_TOLERANCE)
  }, [])

  useEffect(() => {
    updateScrollButtons()
    const el = scrollRef.current
    if (!el) return undefined
    el.addEventListener('scroll', updateScrollButtons)
    window.addEventListener('resize', updateScrollButtons)
    return () => {
      el.removeEventListener('scroll', updateScrollButtons)
      window.removeEventListener('resize', updateScrollButtons)
    }
  }, [updateScrollButtons, totals])

  const scroll = (direction) => {
    const el = scrollRef.current
    if (!el) return
    el.scrollBy({ left: direction * SCROLL_AMOUNT, behavior: 'smooth' })
  }

  return (
    <div className={css.carouselWrapper}>
      {!canScrollLeft ? null : (
        <button
          type="button"
          className={classNames(css.carouselButton, css.carouselButtonLeft)}
          onClick={() => scroll(-1)}
        >
          <SVG icon="carousel-left" className={css.carouselButtonIcon} />
        </button>
      )}
      <div className={css.carousel} ref={scrollRef}>
        {totals.map(t => <Tile {...tileProps} {...t} selected={selectedFilter === t.type} onClick={handleFilterClick} custom={!!t.customFilter} key={t.type} loading={loading} />)}
      </div>
      {!canScrollRight ? null : (
        <button
          type="button"
          className={classNames(css.carouselButton, css.carouselButtonRight)}
          onClick={() => scroll(1)}
        >
          <SVG icon="carousel-right" className={css.carouselButtonIcon} />
        </button>
      )}
    </div>
  )
}
